export default class Errors {
    public static readonly invalidUserData: string = "Invalid User Data";
}